import { useCallback } from "react";

import { useUpdateSoundMutation } from "api/generated";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { selectSound, setSound } from "store/slices/user";
import { processApiError } from "utils/processApiError";

/**
 * AIDEV-NOTE: Jediné místo, které čte a zapisuje centrální volbu šumu třídy. Cvičení
 * (tlačítko reproduktoru) i nastavení zkoušky zapisují sem, aby se volby nerozcházely.
 * Neuložená volba (null) je vypnuto. Zápis je optimistický — zvuk poslouchá volbu
 * studenta hned, selhání mutace jde jen do Sentry. [TD-368]
 */
export const useBackgroundSound = () => {
  const dispatch = useAppDispatch();
  const withSound = useAppSelector(selectSound) === true;
  const [updateSound] = useUpdateSoundMutation();

  const setWithSound = useCallback(
    (next: boolean) => {
      dispatch(setSound(next));
      updateSound({ withSound: next }).unwrap().catch(processApiError);
    },
    [dispatch, updateSound],
  );

  return { withSound, setWithSound };
};
